import { getMeta, formatCommentText } from '../utils/notification-helpers';
import NotificationIcon from '../NotificationIcon';
import CommentCircleIcon from '../../../../assets/comment-circle-icon.svg';

const NewsletterCommentReplyNotification = ({ notification }) => {
  const meta = getMeta(notification);
  const displayComment = formatCommentText(meta.commentText);

  return (
    <div className="flex items-start gap-2">
      <NotificationIcon avatarSrc={meta.avatar} subIcon={CommentCircleIcon} />
      <div className="ml-2 min-w-0 w-[85%]">
        <p className="text-sm text-growth-green-900">
          <span className="font-bold">
            {meta.firstName} {meta.lastName}
          </span>
          <span> replied to your</span>{' '}
          <span className="font-extrabold text-growth-green">comment</span>
        </p>

        {meta.articleTitle && (
          <p className="text-sm text-gray-600 mb-2">on "{meta.articleTitle}"</p>
        )}

        {displayComment && (
          <div className="bg-white rounded-md p-2 mb-2 border border-[#E5E7EB] mt-2">
            <p className="text-xs text-black break-words">"{displayComment}"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsletterCommentReplyNotification;
